var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


let userCountry = 'US';

console.log('Calling IP');

$.get("https://ipinfo.io?token=f866845c045be6", function (response) {
  console.log('Response');
  console.log(response);
  userCountry = response.country;
  setLocation();
  checkGridProducts();
  checkRecommended();
}, "jsonp");


function setLocation(){
    console.log('SET LOCATION');
  
//  let selectOption;
  let currentOption;
  $('.variant-Location').find('.variant-input').each(function( index ) {
    console.log( index + ": " + $( this ).text() );
    let strText = $( this ).find('label').text().trim();
    let strTextArr = strText.split("-");
    let strText2Arr = strTextArr[0].split("/");
    
    currentOption = strTextArr[0].trim();
    selectOption = $(this);
    
    strText2Arr.forEach(function(str) {
    	console.log(str);
      	let trimmedStr = str.trim();
      
      	if(userCountry == trimmedStr){
          let selector = ".variant-Location .variant-input[data-value='"+currentOption+"'] input";
          $(selector).bind('click', function() {
            console.log('trigger click firefox');
          });
          $(selector).trigger('click');
          
      	}
	}); 

  });
  
  console.log('GEO SUB before');
  
  // Subscription page 
  $('.js-geo-subscription').each(function( index ) {
    console.log('GEO SUB');
   	console.log($(this));
    $('[data-var-title]').each(function( index ) {
        let currentTitle = $(this).data('var-title');  
     	if(currentTitle.includes(userCountry)){
          
           console.log('qty '+$(this).data('var-qty'))
           
          if($(this).data('var-qty') == 0){
            
            let productURL = $(this).parent().find('#add-to-cart').data('url');
            $(this).parent().find('#add-to-cart').click(function(e) {
              e.preventDefault();              
              window.location.href = 'https://pinfinityar.com'+productURL;
            });
       		
          } else{
            $(this).parent().find('.js-subscription-id').val($(this).data('var-id'));
          }
         
          
        }
    });
    
  });
  
  
}

function checkGridProducts(){
  console.log('CHECK GRID PRODUCT'); 
  $('.grid-product').each(function( index ) {
   let thisProduct = $(this);
   let linkHref = $(this).find('.grid-product__link').attr('href')+'.js';
    jQuery.getJSON(linkHref, function(product) {
      console.log(product);
      console.log('variant');
      
      let product1 = product;
      if($('body').hasClass('template-search')){
        product1 = product.product;
      }
      
      let isAvailble = false;
      let productPrice; 
      let comparePrice;
      if(product1.variants){
      if(product1.variants.length > 1){ 
        product1.variants.forEach(function(variant) {
          console.log(variant);
          let variantSplit = variant.title.split("/");
          console.log(variantSplit);
          variantSplit.forEach(function(split) {
            console.log('split '+split);
            if(split == userCountry){
              isAvailble = variant.available;
              productPrice = variant.price;
              comparePrice = variant.compare_at_price;
              console.log(isAvailble,productPrice,comparePrice);
              
              let soldOutHtml = '<div class="grid-product__tag grid-product__tag--sold-out">Sold Out</div>'
              if(isAvailble == false){
                $(thisProduct).find('.grid-product__link').addClass('grid-product__link--disabled');
                console.log('test');
                console.log($(thisProduct).find('.grid-product__tag--sold-out'));
                if($(thisProduct).find('.grid-product__tag--sold-out').length == 0 ){
                   $(thisProduct).find('.grid-product__content').append(soldOutHtml);                  
                }
              } else
              {
                $(thisProduct).find('.grid-product__link').removeClass('grid-product__link--disabled');
                $(thisProduct).find('.grid-product__tag--sold-out').remove();                                
              }
              
              let priceHTML;
              if(comparePrice == null || comparePrice == 0 || comparePrice <= productPrice){
              		priceHTML = '<span class="sale-price">'+Shopify.formatMoney(productPrice, "${{amount}}")+'</span>'
              } else {
              		priceHTML = '<span class="grid-product__price--original">'+Shopify.formatMoney(comparePrice, "${{amount}}")+'</span><span class="sale-price">'+Shopify.formatMoney(productPrice, "${{amount}}")+'</span>'
              }
              $(thisProduct).find('.grid-product__price').html(priceHTML); 
              
            }
          });

        });
      } 
    }
    });
  });
}

function checkRecommended(){
  console.log('is there - '+$('.tdf_rec_stable_div'));
	
}